module.exports = __webpack_public_path__ + "static/img/rs_bot1.e09f4d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/rs_bot1.png
// module id = L1E0
// module chunks = 1